import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { Table } from 'antd'

import {
  StyledPageActionButton,
  StyledPageActions,
  StyledPageHeader,
  StyledPageTitle,
} from '../../../common/components/styled'
import { APP_ROUTES, PERMISSIONS } from '../../../common/constants'
import { useDocumentTitle } from '../../../common/hooks'

import { PermissionGuard } from '../../../account/components/sections'
import { useSopsQuery } from '../../hooks'
import { SopsTableActionColumn } from '../sections'

const SopsPage = () => {
  useDocumentTitle(APP_ROUTES.MISC.children.SOPS.label)

  const { data, isLoading } = useSopsQuery()

  const tableColumns = useMemo(
    () => [
      {
        title: 'SOP',
        render: ({ name, link }) => (
          <a href={link} rel="noreferrer" target="_blank">
            {name}
          </a>
        ),
      },
      {
        align: 'right',
        render: ({ id }) => <SopsTableActionColumn id={id} />,
      },
    ],
    [],
  )

  return (
    <>
      <StyledPageHeader>
        <StyledPageTitle>Documentation</StyledPageTitle>

        <StyledPageActions>
          <PermissionGuard permissions={PERMISSIONS.SOP.CREATE}>
            <StyledPageActionButton>
              <Link to={APP_ROUTES.MISC.children.SOPS.children.SOP_CREATE.path}>
                Add SOP
              </Link>
            </StyledPageActionButton>
          </PermissionGuard>
        </StyledPageActions>
      </StyledPageHeader>

      <Table
        loading={isLoading}
        rowKey="id"
        columns={tableColumns}
        dataSource={data}
        pagination={false}
      />
    </>
  )
}

export default SopsPage
